import { render, staticRenderFns } from "./BaseBtnLastPage.vue?vue&type=template&id=0f94736e&scoped=true&lang=pug"
import script from "./BaseBtnLastPage.vue?vue&type=script&lang=js"
export * from "./BaseBtnLastPage.vue?vue&type=script&lang=js"
import style0 from "./BaseBtnLastPage.vue?vue&type=style&index=0&id=0f94736e&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0f94736e",
  null
  
)

export default component.exports